// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPage_container__8QeQr","rightContainer":"MainPage_rightContainer__2ZzQO"};